import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3ceb2237"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "news-section__section" }
const _hoisted_2 = { class: "news-section__section-title" }
const _hoisted_3 = { class: "news-section__card-list" }
const _hoisted_4 = { class: "news-section__action-list" }

import { IonText } from '@ionic/vue';
import NewsSection from '@/types/NewsSection';
import NewsCard from '@/components/News/NewsCard.vue';
import NewsButton from '@/components/News/NewsButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsSection',
  props: {
    section: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_unref(IonText), { class: "news-section__title-container" }, {
      default: _withCtx(() => [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.section.title), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.section.items, (item, index) => {
        return (_openBlock(), _createBlock(NewsCard, {
          key: `card-${item.title}-${index}`,
          item: item
        }, null, 8, ["item"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.section.actions, (item, index) => {
        return (_openBlock(), _createBlock(NewsButton, {
          key: `action-${item.title}-${index}`,
          action: item
        }, null, 8, ["action"]))
      }), 128))
    ])
  ]))
}
}

})